import * as React from "react";
import _filter from "lodash/filter";
import styled from "styled-components";

export type AlignType = "left" | "center" | "right";

interface IProps {
  inline?: boolean;
  align?: AlignType;
  address?: IAddress | null;
}

interface IAddressWrapper {
  align?: AlignType;
}

const AddressWrapper = styled("span")<IAddressWrapper>`
  text-align: ${({ align }) => align || "inherit"};

  span {
    display: block;
  }
`;

export interface IAddress {
  addressLine1: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  postcode: string;
}

/**
 * Output the address accordingly
 */
const Address = ({
  inline, align, address
}: IProps) => {
  // If no address was given return -
  if (!address) {
    return (
      <AddressWrapper>
        -
      </AddressWrapper>
    );
  }

  // If inline, return the address on one line
  if (inline) {
    return (
      <AddressWrapper align={align}>
        {`${address.addressLine1}, `}

        {address.addressLine2 && `${address.addressLine2}, `}

        {address.addressLine3 && `${address.addressLine3}, `}

        {address.city && `${address.city}, `}

        {address.postcode}
      </AddressWrapper>
    );
  }

  return (
    <AddressWrapper align={align}>
      <span>
        {address.addressLine1}
      </span>

      {address.addressLine2 && (
        <span>
          {address.addressLine2}
        </span>
      )}

      {address.addressLine3 && (
        <span>
          {address.addressLine3}
        </span>
      )}

      {address.city && (
        <span>
          {address.city}
        </span>
      )}

      <span>
        {address.postcode}
      </span>
    </AddressWrapper>
  );
};

export default Address;
